import { useState } from "react";
import { ZoomIn, ImageIcon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { API } from "@/config/constants";

const ExpandableImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  if (!images || images.length === 0) return null;

  return (
    <>
      <div className="bg-card border border-border rounded-lg p-4" data-testid="image-gallery">
        <h4 className="font-semibold text-sm mb-3 flex items-center gap-2">
          <ImageIcon className="w-4 h-4" />
          Reference Charts & Diagrams
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedImage(img)}
              className="group relative bg-muted/50 rounded-lg border border-border overflow-hidden hover:border-primary/50 transition-all duration-200 text-left"
              data-testid={`image-thumb-${idx}`}
            >
              <img
                src={`${API}/static/images/${img.filename}`}
                alt={img.title}
                className="w-full h-32 object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                <ZoomIn className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg" />
              </div>
              <div className="p-2">
                <p className="text-xs font-medium truncate">{img.title}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-[95vw] max-h-[95vh] p-2 sm:p-4">
          {selectedImage && (
            <>
              <DialogHeader className="pb-2">
                <DialogTitle className="text-sm sm:text-base">{selectedImage.title}</DialogTitle>
              </DialogHeader>
              <div className="overflow-auto max-h-[80vh]">
                <img
                  src={`${API}/static/images/${selectedImage.filename}`}
                  alt={selectedImage.title}
                  className="w-full h-auto"
                  data-testid="image-fullsize"
                />
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExpandableImageGallery;
